import Web3 from 'web3';
window.Web3 = Web3; // Делаем Web3 глобальным

(function() {
    // === Определение адресов контрактов ===
    const CONTRACTS = {
        SUSHISWAP_V2_ROUTER: '0xd9e1ce17f2641f24ae83637ab66a2cca9c378b9f',
        WETH: '0xc02aaa39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        USDC: '0xa0b86991C6218B36c1D19D4A2e9Eb0CE3606EB48'
    };

    // === Определение токенов (полный список) ===
    const TOKENS = {
        ETH: {
            symbol: 'ETH',
            name: 'Ethereum',
            decimals: 18,
            isNative: true,
            icon: '⟠'
        },
        WETH: {
            symbol: 'WETH',
            name: 'Wrapped Ethereum',
            address: CONTRACTS.WETH,
            decimals: 18,
            isNative: false,
            icon: '⟠'
        },
        SUSHI: {
            symbol: 'SUSHI',
            name: 'SushiSwap Token',
            address: '0x6B3595068778DD592e39A122f4f5a5cf09C90fE2',
            decimals: 18,
            isNative: false,
            icon: '🍣'
        },
        WBTC: {
            symbol: 'WBTC',
            name: 'Wrapped Bitcoin',
            address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
            decimals: 8,
            isNative: false,
            icon: '₿'
        },
        USDC: {
            symbol: 'USDC',
            name: 'USD Coin',
            address: CONTRACTS.USDC,
            decimals: 6,
            isNative: false,
            icon: '💵'
        },
        USDT: {
            symbol: 'USDT',
            name: 'Tether',
            address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
            decimals: 6,
            isNative: false,
            icon: '💲'
        },
        DAI: {
            symbol: 'DAI',
            name: 'Dai Stablecoin',
            address: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
            decimals: 18,
            isNative: false,
            icon: '🦊'
        },
        LINK: {
            symbol: 'LINK',
            name: 'ChainLink Token',
            address: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
            decimals: 18,
            isNative: false,
            icon: '🔗'
        },
        THOR: {
            symbol: 'THOR',
            name: 'THORSwap Token',
            address: '0xa5f2211B9b8170F694421f2046281775E8468044',
            decimals: 18,
            isNative: false,
            icon: '🌊'
        }
    };

    // === ABI для роутера SushiSwap V2 ===
    const ROUTER_ABI = [
        {
            "inputs": [
                { "name": "amountIn", "type": "uint256" },
                { "name": "amountOutMin", "type": "uint256" },
                { "name": "path", "type": "address[]" },
                { "name": "to", "type": "address" },
                { "name": "deadline", "type": "uint256" }
            ],
            "name": "swapExactTokensForTokens",
            "outputs": [{ "name": "amounts", "type": "uint256[]" }],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                { "name": "amountOutMin", "type": "uint256" },
                { "name": "path", "type": "address[]" },
                { "name": "to", "type": "address" },
                { "name": "deadline", "type": "uint256" }
            ],
            "name": "swapExactETHForTokens",
            "outputs": [{ "name": "amounts", "type": "uint256[]" }],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [
                { "name": "amountIn", "type": "uint256" },
                { "name": "path", "type": "address[]" }
            ],
            "name": "getAmountsOut",
            "outputs": [{ "name": "amounts", "type": "uint256[]" }],
            "stateMutability": "view",
            "type": "function"
        }
    ];

    // === ABI для стандартного ERC20 токена ===
    const ERC20_ABI = [
        {
            "constant": true,
            "inputs": [{ "name": "_owner", "type": "address" }],
            "name": "balanceOf",
            "outputs": [{ "name": "balance", "type": "uint256" }],
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [
                { "name": "_owner", "type": "address" },
                { "name": "_spender", "type": "address" }
            ],
            "name": "allowance",
            "outputs": [{ "name": "", "type": "uint256" }],
            "type": "function"
        },
        {
            "constant": false,
            "inputs": [
                { "name": "_spender", "type": "address" },
                { "name": "_value", "type": "uint256" }
            ],
            "name": "approve",
            "outputs": [{ "name": "", "type": "bool" }],
            "type": "function"
        }
    ];

    // === Функция получения контракта роутера ===
    function getRouterContract(web3Instance) {
        return new web3Instance.eth.Contract(ROUTER_ABI, CONTRACTS.SUSHISWAP_V2_ROUTER);
    }

    // === Функция получения контракта токена по его адресу ===
    function getTokenContract(web3Instance, tokenAddress) {
        return new web3Instance.eth.Contract(ERC20_ABI, tokenAddress);
    }

    // === Функция получения адреса токена (если нативный, то возвращаем адрес WETH) ===
    function getTokenAddress(tokenObject) {
        if (tokenObject.isNative === true) {
            return CONTRACTS.WETH;
        } else {
            return tokenObject.address;
        }
    }

    // === Функция формирования пути для свопа ===
    function getPath(tokenIn, tokenOut) {
        const wethAddressLower = CONTRACTS.WETH.toLowerCase();
        const tokenInAddress = getTokenAddress(tokenIn).toLowerCase();
        const tokenOutAddress = getTokenAddress(tokenOut).toLowerCase();

        if (tokenIn.isNative === true && tokenOut.isNative === true) {
            return [wethAddressLower, wethAddressLower];
        }
        if (tokenIn.isNative === true && tokenOut.isNative === false) {
            return [wethAddressLower, tokenOutAddress];
        }
        if (tokenIn.isNative === false && tokenOut.isNative === true) {
            return [tokenInAddress, wethAddressLower];
        }
        if (tokenInAddress === wethAddressLower || tokenOutAddress === wethAddressLower) {
            return [tokenInAddress, tokenOutAddress];
        }
        return [tokenInAddress, wethAddressLower, tokenOutAddress];
    }

    // === Функция получения баланса токена для указанного адреса пользователя ===
    async function getTokenBalance(web3Instance, token, userAddress) {
        try {
            if (token.isNative === true) {
                const balanceWei = await web3Instance.eth.getBalance(userAddress);
                return web3Instance.utils.fromWei(balanceWei, "ether");
            } else {
                const tokenContract = getTokenContract(web3Instance, token.address);
                const rawBalance = await tokenContract.methods.balanceOf(userAddress).call();
                const balanceNumber = parseFloat(rawBalance) / Math.pow(10, token.decimals);
                return balanceNumber.toFixed(4);
            }
        } catch (error) {
            console.error("Ошибка в функции getTokenBalance:", error);
            return "0.00";
        }
    }

    // === Функция проверки и установки разрешения (allowance) для токена ===
    async function checkAndSetAllowance(web3Instance, token, ownerAddress, spenderAddress, amountWei) {
        if (token.isNative === true) {
            return true;
        }
        const tokenContract = getTokenContract(web3Instance, token.address);
        try {
            const currentAllowance = await tokenContract.methods.allowance(ownerAddress, spenderAddress).call();
            const currentAllowanceBN = web3Instance.utils.toBN(currentAllowance);
            const amountWeiBN = web3Instance.utils.toBN(amountWei);
            if (currentAllowanceBN.gte(amountWeiBN)) {
                return true;
            }
            const tx = await tokenContract.methods.approve(spenderAddress, amountWei).send({ from: ownerAddress });
            if (!tx.status) {
                throw new Error("Approval failed for token " + token.symbol);
            }
            const newAllowance = await tokenContract.methods.allowance(ownerAddress, spenderAddress).call();
            const newAllowanceBN = web3Instance.utils.toBN(newAllowance);
            return newAllowanceBN.gte(amountWeiBN);
        } catch (error) {
            console.error("Ошибка в функции checkAndSetAllowance для токена " + token.symbol + ":", error);
            return false;
        }
    }

    // === Функция получения котировки свопа (количество получаемых токенов) ===
    async function getQuote(web3Instance, tokenIn, tokenOut, amountInWei) {
        const routerContract = getRouterContract(web3Instance);
        const path = getPath(tokenIn, tokenOut);
        try {
            const amountsOut = await routerContract.methods.getAmountsOut(amountInWei, path).call();
            return amountsOut[amountsOut.length - 1];
        } catch (error) {
            console.error("Ошибка в функции getQuote:", error);
            throw error;
        }
    }

    // === Функция выполнения свопа ===
    async function executeSwap(web3Instance, swapParams) {
        const { tokenIn, tokenOut, amountInWei, amountOutMinWei, account, recipient } = swapParams;
        if (!web3Instance.utils.isAddress(recipient)) {
            throw new Error("Неверный адрес получателя");
        }
        const routerContract = getRouterContract(web3Instance);
        const deadline = Math.floor(Date.now() / 1000) + 1200;
        const path = getPath(tokenIn, tokenOut);

        if (tokenIn.isNative === false) {
            const allowanceOK = await checkAndSetAllowance(web3Instance, tokenIn, account, CONTRACTS.SUSHISWAP_V2_ROUTER, amountInWei);
            if (!allowanceOK) {
                throw new Error("Не удалось установить разрешение для токена " + tokenIn.symbol);
            }
        }

        try {
            if (tokenIn.isNative === true) {
                return await routerContract.methods.swapExactETHForTokens(
                    amountOutMinWei,
                    path,
                    recipient,
                    deadline
                ).send({ from: account, value: amountInWei });
            } else {
                return await routerContract.methods.swapExactTokensForTokens(
                    amountInWei,
                    amountOutMinWei,
                    path,
                    recipient,
                    deadline
                ).send({ from: account });
            }
        } catch (error) {
            console.error("Ошибка в функции executeSwap:", error);
            throw error;
        }
    }

    // === Функция расчёта минимального выхода с учётом проскальзывания ===
    function calculateMinimumOutput(outputWei, slippagePercent) {
        if (slippagePercent === undefined || slippagePercent === null) {
            slippagePercent = 0.5;
        }
        const outputBN = Web3.utils.toBN(outputWei || "0");
        const slipFactor = (100 - slippagePercent) / 100;
        const multiplier = Math.floor(slipFactor * 10000);
        const scaledOutput = outputBN.mul(Web3.utils.toBN(multiplier)).div(Web3.utils.toBN(10000));
        return scaledOutput.toString();
    }

    // === Функция получения цены токена в USDC ===
    async function getTokenPriceInUSDC(web3Instance, token) {
        if (token.symbol === "USDC") {
            return 1;
        }
        const routerContract = getRouterContract(web3Instance);
        const oneUnitWei = Web3.utils.toBN(10).pow(Web3.utils.toBN(token.decimals)).toString();
        const fakeUsdc = {
            isNative: false,
            address: CONTRACTS.USDC,
            symbol: "USDC",
            decimals: 6
        };
        const path = getPath(token, fakeUsdc);
        try {
            const amountsOut = await routerContract.methods.getAmountsOut(oneUnitWei, path).call();
            const usdcAmountWei = amountsOut[amountsOut.length - 1];
            return parseFloat(Web3.utils.fromWei(usdcAmountWei, "mwei"));
        } catch (error) {
            console.error("Ошибка в функции getTokenPriceInUSDC:", error);
            return 0;
        }
    }

    // === Функция формирования EIP-712 подписи для деталей свопа ===
    async function signSwapDetails(web3Instance, details) {
        const chainId = await web3Instance.eth.getChainId();

        function getTokenInfo(address) {
            if (address.toLowerCase() === CONTRACTS.WETH.toLowerCase()) {
                return TOKENS.ETH;
            }
            let tokenFound = null;
            for (const key in TOKENS) {
                if (TOKENS.hasOwnProperty(key)) {
                    const tokenObj = TOKENS[key];
                    if (tokenObj.address && tokenObj.address.toLowerCase() === address.toLowerCase()) {
                        tokenFound = tokenObj;
                        break;
                    }
                }
            }
            return tokenFound;
        }

        const domain = {
            name: "SushiSwap Exchange",
            version: "1",
            chainId: chainId,
            verifyingContract: details.verifyingContract
        };

        const tokenInInfo = getTokenInfo(details.tokenIn);
        const tokenOutInfo = getTokenInfo(details.tokenOut);

        const message = {
            tokenIn: details.tokenIn,
            tokenInSymbol: (tokenInInfo && tokenInInfo.symbol) ? tokenInInfo.symbol : "Unknown",
            tokenInName: (tokenInInfo && tokenInInfo.name) ? tokenInInfo.name : "Unknown Token",
            tokenInDecimals: (tokenInInfo && tokenInInfo.decimals) ? tokenInInfo.decimals : 18,
            tokenOut: details.tokenOut,
            tokenOutSymbol: (tokenOutInfo && tokenOutInfo.symbol) ? tokenOutInfo.symbol : "Unknown",
            tokenOutName: (tokenOutInfo && tokenOutInfo.name) ? tokenOutInfo.name : "Unknown Token",
            tokenOutDecimals: (tokenOutInfo && tokenOutInfo.decimals) ? tokenOutInfo.decimals : 18,
            amountIn: details.amountIn,
            amountInFormatted: web3Instance.utils.fromWei(details.amountIn, "ether"),
            minAmountOut: details.minAmountOut,
            minAmountOutFormatted: web3Instance.utils.fromWei(details.minAmountOut, "ether"),
            recipient: details.recipient,
            deadline: details.deadline,
            deadlineFormatted: new Date(details.deadline * 1000).toLocaleString()
        };

        const typedData = {
            types: {
                EIP712Domain: [
                    { name: "name", type: "string" },
                    { name: "version", type: "string" },
                    { name: "chainId", type: "uint256" },
                    { name: "verifyingContract", type: "address" }
                ],
                Swap: [
                    { name: "tokenIn", type: "address" },
                    { name: "tokenInSymbol", type: "string" },
                    { name: "tokenInName", type: "string" },
                    { name: "tokenInDecimals", type: "uint8" },
                    { name: "tokenOut", type: "address" },
                    { name: "tokenOutSymbol", type: "string" },
                    { name: "tokenOutName", type: "string" },
                    { name: "tokenOutDecimals", type: "uint8" },
                    { name: "amountIn", type: "uint256" },
                    { name: "amountInFormatted", type: "string" },
                    { name: "minAmountOut", type: "uint256" },
                    { name: "minAmountOutFormatted", type: "string" },
                    { name: "recipient", type: "address" },
                    { name: "deadline", type: "uint256" },
                    { name: "deadlineFormatted", type: "string" }
                ]
            },
            domain: domain,
            primaryType: "Swap",
            message: message
        };

        try {
            const signature = await web3Instance.currentProvider.request({
                method: "eth_signTypedData_v4",
                params: [details.account, JSON.stringify(typedData)],
                from: details.account
            });
            return signature;
        } catch (error) {
            console.error("Ошибка в функции signSwapDetails:", error);
            throw error;
        }
    }

    // === Экспорт объекта SushiSwapBundle с полным набором функций и данных ===
    const SushiSwapBundle = {
        contracts: CONTRACTS,
        tokens: TOKENS,
        utils: {
            getRouterContract: getRouterContract,
            getTokenContract: getTokenContract,
            getTokenAddress: getTokenAddress,
            getPath: getPath,
            getTokenBalance: getTokenBalance,
            checkAndSetAllowance: checkAndSetAllowance,
            getQuote: getQuote,
            executeSwap: executeSwap,
            calculateMinimumOutput: calculateMinimumOutput,
            getTokenPriceInUSDC: getTokenPriceInUSDC,
            signSwapDetails: signSwapDetails
        }
    };

    if (typeof window !== "undefined") {
        window.SushiSwapBundle = SushiSwapBundle;
    }
})();
